import _ from 'underscore';

import { ready } from './helpers/common';
import { TargetingTypes } from './model/targeting_types';

/**
 * This file contains a mapping of Targetable Element IDs to:
 *   class: model class (used for data validation)
 *   form: Vue form component
 *
 * To avoid circular import references when loading imports between this file
 * (via constants.js) and the various forms which in turn try to load this file,
 * we dynamically create this config map at runtime.
 */

// export a placeholder object
const types = {};
export default types;

// populate the type map on dom ready
ready(() => {
  const t = {
    // geo types
    8: {
      class: TargetingTypes.Country,
    },
    9: {
      class: TargetingTypes.DMA,
    },
    10: {
      class: TargetingTypes.State,
    },
    11: {
      class: TargetingTypes.Radius,
    },
    12: {
      class: TargetingTypes.ZipCodes,
    },
    13: {
      class: TargetingTypes.Geofence,
    },
    14: {
      class: TargetingTypes.Residency,
    },
    23: {
      class: TargetingTypes.Counties,
    },
    24: {
      class: TargetingTypes.City,
    },

    // audience types
    4: {
      class: TargetingTypes.BehavioralSegments,
    },
    42: {
      class: TargetingTypes.SequencialTargeting,
    },
    5: {
      class: TargetingTypes.BehavioralInterest,
    },
    6: {
      class: TargetingTypes.FirstPartyData,
    },
    7: {
      class: TargetingTypes.SearchRetargeting,
    },
    28: {
      class: TargetingTypes.Demographic,
    },
    38: {
      class: TargetingTypes.AudienceNotes,
    },

    // publisher types
    15: {
      class: TargetingTypes.RunOfNetwork,
    },
    33: {
      class: TargetingTypes.SpecificPublisher,
    },
    16: {
      class: TargetingTypes.Blocklist,
    },
    17: {
      class: TargetingTypes.KeywordContextual,
    },
    18: {
      class: TargetingTypes.Allowlist,
    },
    19: {
      // Private publisher / direct to publisher
      class: TargetingTypes.PMP,
    },
    20: {
      class: TargetingTypes.AudioSpecificIndustryVerticals,
    },
    21: {
      class: TargetingTypes.LiveEvents,
    },
    25: {
      class: TargetingTypes.PremiumContent,
    },
    26: {
      class: TargetingTypes.ContentChannel,
    },
    27: {
      class: TargetingTypes.ContentVertical,
    },
    29: {
      class: TargetingTypes.CTVRON,
    },
    30: {
      class: TargetingTypes.PremiumOTT,
    },
    31: {
      class: TargetingTypes.PremiumCTV,
    },
    32: {
      class: TargetingTypes.CustomXandrSegments,
    },
    39: {
      class: TargetingTypes.PublisherNotes,
    },
    40: {
      class: TargetingTypes.FlipOTT,
    },
    41: {
      class: TargetingTypes.ContextualTargeting,
    },
  };

  if (_.isEmpty(types)) {
    Object.assign(types, t);
  } else {
    // deep merge it into existing types obj
    Object.keys(t).forEach((k) => {
      Object.assign(types[k], t[k]);
    });
  }
});
